import {
  PropertyPartWithProperty,
  propertyPartWithPropertySchema,
} from "@boark/shared/types/property-part-with-property";
import * as z from "zod";

import { getRequest, request } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getPropertyParts(): Promise<PropertyPartWithProperty[]> {
  return request(`${API_BASE_URL}/property-part`, {
    schema: z.array(propertyPartWithPropertySchema),
    headers: { "Content-Type": "application/json" },
  });
}

export async function getPropertyPart(
  id: string,
): Promise<PropertyPartWithProperty> {
  return getRequest(
    `${API_BASE_URL}/property-part/${id}`,
    propertyPartWithPropertySchema,
  );
}

export function formatPropertyPartLabel(
  propertyPart: PropertyPartWithProperty,
): string {
  return `${propertyPart.code} – ${propertyPart.name} (${propertyPart.property.name})`;
}
